import { render, staticRenderFns } from "./editSemiOriginal.vue?vue&type=template&id=3304cbeb&"
import script from "./editSemiOriginal.vue?vue&type=script&lang=js&"
export * from "./editSemiOriginal.vue?vue&type=script&lang=js&"
import style0 from "./editSemiOriginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports